import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Duo extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M7.736,12.208H0v3.968H3.872a4.011,4.011,0,0,0,3.864-3.968" />
        <path d="M3.872,7.824H0v3.968H7.74A4.018,4.018,0,0,0,3.872,7.824" />
        <path d="M20.132,7.824a4.018,4.018,0,0,0-3.868,3.968H24a4.009,4.009,0,0,0-3.864-3.968" />
        <path d="M24,12.208H16.264a4.012,4.012,0,0,0,3.868,3.968A4.015,4.015,0,0,0,24,12.208" />
        <path d="M8.128,7.824V12a4.051,4.051,0,0,0,3.68,4.172V7.824Z" />
        <polygon points="15.872 7.824 12.196 7.824 12.196 16.176 15.872 16.176 15.872 12 15.872 7.824" />
      </svg>
    );
  }
}

export default Duo;
